var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 36.6663C10.7952 36.6663 3.3335 29.2047 3.3335 19.9997C3.3335 10.7947 10.7952 3.33301 20.0002 3.33301C29.2052 3.33301 36.6668 10.7947 36.6668 19.9997C36.6668 29.2047 29.2052 36.6663 20.0002 36.6663ZM18.3385 26.6663L30.1218 14.8813L27.7652 12.5247L18.3385 21.953L13.6235 17.238L11.2668 19.5947L18.3385 26.6663Z",
    fill: "#27C81A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGreen);
export default __webpack_public_path__ + "static/media/checkbox_green.b105395ec0c7b066941ea8b925d480ad.svg";
export { ForwardRef as ReactComponent };